import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import CloseIcon from '@/assets/icon/close.svg';
import { SccButton } from '@/components/atoms';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Modal, ScrollView, View } from 'react-native';
import { SccTouchableOpacity } from '@/components/SccTouchableOpacity';
import styled from 'styled-components/native';
import { ScreenLayout } from '@/components/ScreenLayout';
import FormFieldRenderer from '@/components/molecules/FormFieldRenderer';
import { toFormField, validateForm, transformToApiRequest, } from '@/types/b2bForm';
const ChallengeDetailCompanyModal = ({ isVisible, onPressCloseButton, onPressConfirmButton, formSchema, }) => {
    const [formState, setFormState] = useState({});
    const [fields, setFields] = useState([]);
    // Convert API DTO to FormField array
    useEffect(() => {
        if (formSchema === null || formSchema === void 0 ? void 0 : formSchema.availableFields) {
            const convertedFields = formSchema.availableFields.map(dto => toFormField(dto));
            setFields(convertedFields);
        }
    }, [formSchema]);
    // Reset form state
    const reset = useCallback(() => {
        setFormState({});
    }, []);
    // Update field value
    const handleFieldChange = useCallback((key, value) => {
        setFormState(prev => (Object.assign(Object.assign({}, prev), { [key]: value })));
    }, []);
    // Get field value
    const getFieldValue = useCallback((key) => {
        return formState[key] || '';
    }, [formState]);
    // Validate form
    const isFormValid = useMemo(() => {
        const validation = validateForm(formState, fields);
        return validation.isValid;
    }, [formState, fields]);
    return (_jsx(Modal, { visible: isVisible, statusBarTranslucent: true, children: _jsxs(ScreenLayout, { isHeaderVisible: false, safeAreaEdges: ['top', 'bottom'], style: { flex: 1 }, children: [_jsx(SccTouchableOpacity, { elementName: "challenge_modal_close_button", onPress: () => {
                        onPressCloseButton();
                        reset();
                    }, style: {
                        alignItems: 'flex-end',
                        paddingHorizontal: 20,
                        paddingVertical: 13,
                    }, children: _jsx(CloseIcon, { width: 24, height: 24, color: color.gray90 }) }), _jsxs(ScrollView, { bounces: false, contentContainerStyle: {
                        flexGrow: 1,
                        paddingHorizontal: 20,
                        gap: 36,
                    }, children: [_jsxs(View, { children: [_jsx(Title, { children: "\uCC4C\uB9B0\uC9C0 \uCC38\uC5EC\uB97C \uD658\uC601\uD569\uB2C8\uB2E4!" }), _jsx(Description, { children: "\uC11C\uBE44\uC2A4 \uC0AC\uC6A9\uC5D0 \uD544\uC694\uD55C \uC815\uBCF4\uB97C \uC54C\uB824\uC8FC\uC138\uC694." })] }), fields.map(field => (_jsx(FormFieldRenderer, { field: field, value: getFieldValue(field.key), onChange: value => handleFieldChange(field.key, value), elementNamePrefix: "b2b-form" }, field.key)))] }), _jsx(ButtonContainer, { children: _jsx(ConfirmButton, { isDisabled: !isFormValid, text: "\uD655\uC778", textColor: "white", buttonColor: "brandColor", fontFamily: font.pretendardBold, onPress: () => {
                            const companyInfo = transformToApiRequest(formState, fields);
                            onPressConfirmButton(companyInfo);
                            reset();
                        }, elementName: "challenge_company_modal_confirm" }) })] }) }));
};
export default ChallengeDetailCompanyModal;
export const Title = styled.Text({
    color: color.black,
    fontSize: 24,
    fontFamily: font.pretendardBold,
});
export const Description = styled.Text({
    color: color.black,
    fontSize: 16,
    fontFamily: font.pretendardRegular,
    marginTop: 8,
});
export const InputWrapper = styled.View({
    paddingHorizontal: 24,
    gap: 8,
    marginTop: 30,
});
export const InputLabel = styled.Text({
    fontFamily: font.pretendardMedium,
    fontSize: 13,
});
export const ButtonContainer = styled.View({
    flexDirection: 'row',
    gap: 10,
    paddingVertical: 20,
    paddingHorizontal: 20,
});
export const CloseButton = styled(SccButton) `
  flex: 1;
`;
export const ConfirmButton = styled(SccButton) `
  flex: 1;
`;
export const Overlay = styled.View({
    position: 'absolute',
    inset: 0,
    backgroundColor: color.blacka50,
    zIndex: 9999,
});
